<template>
  <div class="relative flex flex-col min-w-0 break-words w-full h-full mb-4 shadow-lg rounded-lg bg-white card-zoom"
    @mouseover="zoomIn" @mouseleave="zoomOut">

    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            Total Number of Each Basic Data
          </h6>
          <h2 class="text-blueGray text-xl font-semibold">
            Basic Information
          </h2>
        </div>
      </div>
    </div>
    <div class="p-4 pt-8 flex-auto ">
      <div class="flex flex-wrap">

        <div class="w-full lg:w-4/12 mr-auto px-4 pt-6 pb-4 h-full mb-2 shadow-lg rounded-lg border-0 bg-lightBlue-200 ">
          <router-link to="/subject">
            <div
              class="text-white p-3 text-center mr-2 mb-4 inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-lightBlue-500">
              <i class="fa fa-folder-open"></i>
            </div>
            <span class="text-blueGray text-xl font-semibold text-blueGray">
              Subjects Present in Curriculum
            </span>

            <div class="block w-full overflow-x-auto">
              <table class="items-center w-full pt-2 rounded bg-white">
                <tbody>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Doctor of Medicine Program
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ subject_arr.doctor === '0' ? subject_arr.doctor +' Subject' : subject_arr.doctor + ' Subjects' }}
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Bachelor of Science (Radiological Technology)
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ subject_arr.radio === '0' ? subject_arr.radio +' Subject' : subject_arr.radio + ' Subjects' }} 
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Bachelor of Science (Physical Therapy)
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ subject_arr.therapy === '0' ? subject_arr.therapy +' Subject' : subject_arr.therapy + ' Subjects' }} 
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Bachelor of Science (Emergency Medical Operation)
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ subject_arr.er === '0' ? subject_arr.er +' Subject' : subject_arr.er + ' Subjects' }} 
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </router-link>
        </div>


        <div class="w-full lg:w-4/12 mr-auto px-4 pt-6 pb-4 h-full mb-2  shadow-lg rounded-lg border-0 bg-lightBlue-200">
          <router-link to="/lecturer">
            <div
              class="text-white p-3 mr-2 mb-4 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-lightBlue-500">
              <i class="fa fa-users"></i>
            </div>
            <span class="text-blueGray text-xl font-semibold text-blueGray">
              Staffs
            </span>

            <div class="block w-full overflow-x-auto">
              <table class="items-center w-full pt-2 bg-transparent rounded bg-white">
                <tbody>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Faculty of Medicine
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ teacher_arr.t_moror === '0' ? teacher_arr.t_moror +' Person' : teacher_arr.t_moror + ' Persons' }} 
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Other Faculty (Within PSU)
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ teacher_arr.t_psu === '0' ? teacher_arr.t_psu +' Person' : teacher_arr.t_psu + ' Persons' }} 
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Other Institutions (Outside PSU)
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ teacher_arr.t_other === '0' ? teacher_arr.t_other +' Person' : teacher_arr.t_other + ' Persons' }} 
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Affiliated Institutions
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ teacher_arr.t_hospital === '0' ? teacher_arr.t_hospital +' Person' : teacher_arr.t_hospital + ' Persons' }} 
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </router-link>
        </div>

        <div class="w-full lg:w-4/12 px-4 pt-6 pb-4 h-full shadow-lg mb-2 rounded-lg border-0 bg-lightBlue-200">
          <router-link to="/resource">
            <div
              class="text-white mr-2 mb-4 p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-lightBlue-500">
              <i class="fa fa-share-alt"></i>
            </div>
            <span class="text-blueGray text-xl font-semibold text-blueGray">
              Learning Resources
            </span>

            <div class="block w-full overflow-x-auto">
              <table class="items-center w-full pt-2 bg-transparent rounded bg-white">
                <tbody>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Classroom
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ resource_arr.classroom === '0' ? resource_arr.classroom +' Room' : resource_arr.classroom + ' Rooms' }} 
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Simulated Patient
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ resource_arr.patients === '0' ? resource_arr.patients +' Person' : resource_arr.patients + ' Persons' }} 
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left">
                      Simulated Model
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                      {{ resource_arr.article === '0' ? resource_arr.article +' Model' : resource_arr.article + ' Models' }} 
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left text-white">
                      .
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from './../../services/student_services';
export default {
  name: "card-stats",
  data() {
    return {
      openTab: 1,
      subject_arr: [],
      teacher_arr: [],
      all_teacher: [],
      resource_arr: [],
      all_resource: [],
      student_course: []
    }
  },
  methods: {
    zoomIn() {
      this.$el.style.transform = "scale(1.05)";
    },
    zoomOut() {
      this.$el.style.transform = "scale(1)";
    },
    async subject() {
      api.subject().then(async (result) => {
        this.subject_arr = result.data;

      });
    },
    async teacher() {
      api.teacher().then(async (result) => {
        this.teacher_arr = result.data;
        this.all_teacher = (parseInt(this.teacher_arr.t_moror) + parseInt(this.teacher_arr.t_psu) + parseInt(this.teacher_arr.t_hospital)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      });
    },
    async resource() {
      api.resource().then(async (result) => {
        this.resource_arr = result.data;
        this.all_resource = (parseInt(this.resource_arr.patients) + parseInt(this.resource_arr.classroom) + parseInt(this.resource_arr.article)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      });

    }

  }, created: async function () {
    await this.subject(),
      await this.teacher(),
      await this.resource()
  },
};
</script>